/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员==》查找人员,可在该角色下添加人员
 * @Date 2020/1/2
 */
import React from "react";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "@/utils";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import {WizModalUserIdentityShow} from '@/containers/common';
const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;

import createColumns from "./listSelectColumns";

class ListSelect extends WizContainer {
  componentName = "ListSelect";

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null,
      personId: '',
      showUserPersonInfoVisible: false
    };
  }

  static defaultProps = {
    selectedRows: []
  }

  propsAndStateOnChange = {
    updateUser: this._userOnChange.bind(this),
    addUser: this._userOnChange.bind(this)
  };

  _userOnChange(nextProps, nextState) {
    this._getData();
    return true;
  }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  _getData(other = {}) {
    this.doAction({
      path: "personInfo/getPersonAndUserInfoFilter",
      payload: {
        key: "userListKey",
        apiParams: { ...this.state.apiParams, ...other ,excludeRoleId:this.props.roleId,disabled:0,state:1}
      }
    });
  }

  _onManagement(record){
    this._showUserPersonModal(record.personId);
  }

  /**
   * 获取查看学员任职信息
   * @param personId
   * @private
   */
  _showUserPersonModal = (personId) => {
    this.setState({
      personId : personId,
      showUserPersonInfoVisible: true,
    })
  };

  _render() {
    const { userList, userManagementLoading, selectedRows, updateRows, handleClear } = this.props;
    const { record, visible ,showUserPersonInfoVisible,personId} = this.state;
    const dataItems = getPageData(userList.data);
    const other = {};
    const columns = createColumns(this, dataItems, other);

    let lookUserPersonInfoModal = {
      title: '查看任职信息',
      visible: showUserPersonInfoVisible,
      personId: personId,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          personId: '',
        });
      },
    };
    const searchBarProps = {
      columns,
      collapse: false,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this._getData();
        })
    };

    const dataTableProps = {
      loading: userManagementLoading,
      columns,
      rowKey: "personId",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._getData({ current: pageNum, size: pageSize });
      },
      selectedRowKeys: selectedRows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        let newRows = [];
        let allRows =  new Set([...selectedRows, ...rows]);
        // selectedRows.concat(rows)
        // 根据keys获取最终选中的行数据
        keys.forEach(key => {
          let repeatRow = true;
          allRows.forEach(row=>{
            if(row.personId==key && row.id && repeatRow){
              repeatRow = false;
              newRows.push(row);
            }
          })
        });
        updateRows(newRows)
      }
    };

    const listSelectProps = {
      type: '人员',
      rows: selectedRows,
      handerClear: (id) => {
        handleClear(id)
      }
    }

    return (
      <WizRow>
        <WizCol span={18}>
          <WizCard bodyStyle={{ padding: '0 15px' }}>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{ xs: 14, md: 12, xl: 10 }}
            />
            <WizDataTable style={{ marginTop: 15 }} {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>
        <WizCol span={6} >
          <WizListSelect { ...listSelectProps } />
        </WizCol>
        <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { personInfo } = state;
  const userList = modelUtils.getModelEntity(personInfo, "userListKey");
  const addUser = modelUtils.getModelEntity(personInfo, "addUser");
  const updateUser = modelUtils.getModelEntity(personInfo, "updateUser");
  const load = modelUtils.getLoadingState(state, "personInfo");
  return {
    userList: userList,
    addUser,
    updateUser,
    ...load
  };
};


export default connect(mapStateToProps)(ListSelect);
